import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslations } from "../../i18n";
import { useUserWaitlistBookings } from "./use-user-waitlist-bookings";
import { useAuthStore } from "@/store/auth-store";

export function useWaitlistJoin() {
  const [isJoining, setIsJoining] = useState(false);
  const t = useTranslations("calendar");
  const { refresh } = useUserWaitlistBookings();

  const joinWaitlist = async (classSessionId: string) => {
    if (isJoining) return;
    setIsJoining(true);

    try {
      const res = await fetch("/api/widget/waitlist/join", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ classSessionId }),
      });

      if (res.status === 401) {
        useAuthStore.getState().logout();
        return;
      }

      if (!res.ok) {
        throw new Error(`API error: ${res.status}`);
      }

      const data: { position?: number; alreadyWaitlisted?: boolean } = await res.json();

      if (data.alreadyWaitlisted) {
        const msg = t("waitlistPosition").replace("{{position}}", String(data.position ?? ""));
        toast(msg, { icon: "⏳" });
      } else {
        toast.success(t("waitlistJoined"));
      }

      await refresh();
    } catch {
      toast.error(t("waitlistError"));
    } finally {
      setIsJoining(false);
    }
  };

  return { joinWaitlist, isJoining };
}
